import styled, { css, keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const skeletonStyles = css`
  animation: ${shimmer} 1.5s ease-in-out infinite;
  background: linear-gradient(
    90deg,
    ${({ theme }) => (theme.customized.utils.isNavBarDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.06)')} 0px,
    ${({ theme }) => (theme.customized.utils.isNavBarDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)')} 40px,
    ${({ theme }) => (theme.customized.utils.isNavBarDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.06)')} 80px
  );
  background-size: 200px 100%;
  border-radius: 4px;
`;

// Desktop styles
export const DesktopWrapper = styled.div`
  background: var(--dct--customized-colors-navBar);
  border-bottom: 1px solid #c8d2db;

  @media (max-width: 879px) {
    display: none;
  }
`;

export const DesktopContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1240px;
  padding: 0 20px;
  position: relative;
  width: 100%;
`;

export const DesktopNav = styled.nav`
  align-items: center;
  display: flex;
  flex: 1;
  gap: 20px;
  min-height: 68px;
`;

export const DesktopUtilityNav = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  position: relative;
`;

export const DesktopInBetweenMq = styled.div`
  @media (min-width: 880px) and (max-width: 1019px) {
    display: none;
  }

  @media (min-width: 1020px) {
    align-items: center;
    display: flex;
    gap: 20px;
  }
`;

// Mobile styles
export const MobileWrapper = styled.div`
  background: var(--dct--customized-colors-navBar);
  border-bottom: 1px solid #c8d2db;
  padding: 12px;

  @media (min-width: 880px) {
    display: none;
  }
`;

export const MobileContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  position: relative;
  width: 100%;
`;

export const MobileUtilityNav = styled.div`
  align-items: center;
  display: flex;
  gap: 20px;
  position: relative;
`;

// Skeleton elements
export const SkeletonNavItem = styled.div`
  ${skeletonStyles}
  height: 20px;
  width: 50px;
`;

export const SkeletonMenuButton = styled.div`
  ${skeletonStyles}
  height: 24px;
  width: 70px;
`;

export const SkeletonSearchButton = styled.div`
  ${skeletonStyles}
  height: 20px;
  width: 65px;
`;

export const SkeletonSearchContainer = styled.div`
  flex: 1;
`;

export const SkeletonUserButton = styled.div`
  ${skeletonStyles}
  height: 24px;
  width: 24px;
  border-radius: 50%;
`;

export const SkeletonCartButton = styled.div`
  ${skeletonStyles}
  border-radius: var(--dct--customized-radius-sm);
  height: 32px;
  width: 59px;

  @media (min-width: 880px) {
    height: 44px;
    width: 67px;
  }
`;

export const SkeletonStoreStatus = styled.div`
  ${skeletonStyles}
  height: 18px;
  width: 80px;
`;

export const SkeletonMenuType = styled.div`
  ${skeletonStyles}
  height: 18px;
  width: 60px;
`;

export const Divider = styled.div`
  border-left: 1px solid ${({ theme }) => (theme.customized.utils.isNavBarDark ? '#2c2c2c' : '#c8d2db')};
  height: 36px;
`;
